export const ASYNC_COMPONENTS = {
  CompetenceCard: () => import('@/components/parts/competences/card/Card.vue'),
  ItemSingle: () =>
    import('@/components/parts/catalog/list/item/single/component.vue'),
  ProfessionListCard: () =>
    import('@/components/parts/professions/card/ProfessionListCard.vue'),
  OrganizationSingleItem: () =>
    import(
      '@/components/parts/catalog/list/single_item/OrganizationSingleItem.vue'
    ),
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppCardsList/consts.ts